import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "investigation",
  "use": "investigation-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"investigation\"><g fill-rule=\"evenodd\"><path d=\"M9.042 0v1.25H4.375V0h-1.5v1.25H0v14.73h13.5V1.25h-2.958V0h-1.5zm1.5 4V2.75H12v11.73H1.5V2.75h1.375V4h1.5V2.75h4.667V4h1.5z\" /><path d=\"M2.739 8.538h3.592V4.995H2.739zM2.705 13.008h3.662V9.465H2.705zM7.137 8.538h3.591V4.995H7.137zM7.103 13.008h3.661V9.465H7.103z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id